import { DOCUMENT } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { SettingsService } from "../../shared/services/settings.service";
import { ShortLinkService } from "./shortLink.service";

@Component({
  selector: "new-ui-short-link",
  template: "<p>Redirecting...</p>",
})
export class NewUiShortLinkComponent implements OnInit {
  constructor(
    private readonly settings: SettingsService,
    private readonly shortLinkService: ShortLinkService,
    @Inject(DOCUMENT) private readonly document: Document
  ) {}

  ngOnInit(): void {
    this.shortLinkService.resolveShortLink(location.href).subscribe((url) => {
      if (url) {
        this.document.defaultView.location.href = url;
      } else {
        this.settings.navigateToNotFound();
      }
    });
  }
}
